import { createReducer, on } from '@ngrx/store';
import { MdmAvailableOsUpdatesApiActions } from './mdm-available-os-updates.actions';
import { adapter, initialState } from './mdm-available-os-updates.state';

export const mdmAvailableOsUpdatesFeatureKey = 'mdmAvailableOsUpdates';

export const mdmAvailableOsUpdatesReducer = createReducer(
  initialState,
  on(MdmAvailableOsUpdatesApiActions.availableOSUpdatesLoaded, (state, { availableOsUpdates }) =>
    adapter.upsertMany(availableOsUpdates, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMdmAvailableOsUpdatesIds = selectIds;

export const selectMdmAvailableOsUpdatesEntities = selectEntities;

export const selectAllMdmAvailableOsUpdates = selectAll;
